//Libraries
import { Component, OnInit } from '@angular/core';
import { Router }   from '@angular/router';
// Services
import { SessionService } from '../../../../common/modules/user/services/SessionService';
import { UserService } from '../../../../common/modules/user/services/UserService';
import { HolRegisterService } from '../../../services/HolRegisterService';
//Models
import { Credential } from '../../../../common/modules/user/models/Credential';

@Component({
    selector: 'user-register',
    template: require('./RegisterComponent.html'),
    styles: [require('./RegisterComponent.sass')]
})

export class RegisterComponent implements OnInit {
    message: string;
    messageType: string;
    redirectUrl: string;
    credential: Credential;
    formSubmitted: boolean = false;

    constructor(
        private sessionService: SessionService,
        private userService: UserService,
        private registerService: HolRegisterService,
        private router: Router
    ) {}
    ngOnInit() {
        this.credential = new Credential('hol-parent', '', '');

        // Use Session Service to get session and check if user had already logged in.
        this.getSession();
    }

    onSubmit() {
        this.formSubmitted = true;
        // Reset message content
        this.message = "";
        // Post user login data to create session
        this.register(this.credential);
    }
    
    /**
     * Get Session from API service to make sure that user had logged in.
     * Update User Data on local storage and redirect to the desired URL 
     * if request responses session data.
     * @param none
     * @return none
     */
    private getSession() {
        this.sessionService.getSession()
            .subscribe(
                user => {
                    this.userService.setUserSessionData(user);
                    this.redirect();
                },
                error => {
                    //TO DO: Handle any error if needed in the furture
                    this.message     = "";
                    this.messageType = "alert";
                }
            );
    }

    private register(credential: Credential) {
        this.registerService.postNoneAisAccount(credential.email)
            .subscribe(
                complete => {
                    this.messageType = "success",
                    this.message = "An activation email had been sent.";
                    this.formSubmitted = false;
                    this.redirectUrl = '/add-parent';
                    this.redirect();
                },
                error => {
                    this.messageType = "alert";
                    this.message = "Please input the email you provided to AIS.";
                    this.formSubmitted = false;
                }
            );
    }

    private redirect() {
        // Redirect to stored url
        this.router.navigate([this.redirectUrl]);
    }
 }


// WEBPACK FOOTER //
// ./src/holiday/parent/register-management/register/RegisterComponent.ts